import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-da64ba60"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tenant-user-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_4 = {
  class: "pagination-box"
};
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { Search, Refresh } from '@element-plus/icons-vue';
import usePagination from '@/hooks/usePagination';
import { indexMethod } from '@/utils/indexMethod';
import TenantUser from './components/TenantUser';
import { formSchemas } from './components/config';
import { findHisLoginUserPage } from '@/api/tenant';
export default {
  __name: 'index',
  setup(__props) {
    const formSchemasRef = ref(formSchemas);
    const route = useRoute();
    const {
      tenantId
    } = route.params;
    formSchemasRef.value.find(item => item.field === 'tenantId').defaultValue = tenantId;
    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const tableData = ref([]);
    const loading = ref(false);
    const keyword = ref('');
    const _getUserPageListByTenantId = async () => {
      loading.value = true;
      const res = await findHisLoginUserPage({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        keyword: keyword.value,
        tenantId: tenantId
      });
      tableData.value = res.records;
      setTotal(res.total);
      loading.value = false;
    };
    _getUserPageListByTenantId();

    // const roles = ref([])
    // const addRoleByTenant = async () => {
    //   const res = await getRoleList({
    //     tenantId
    //   })
    //   formSchemasRef.value.find((item) => item.field === 'userRoleList').checkboxArr = res
    //   roles.value = res
    // }

    // addRoleByTenant()

    const handleCurrentChange = e => {
      setCurrentPage(e);
      _getUserPageListByTenantId();
    };

    // 添加租户用户
    const tenantUserVisible = ref(false); // show or hide

    const currentTenantUser = ref(null);
    const addUserHandler = () => {
      tenantUserVisible.value = true;
    };
    const handleUpdateUser = row => {
      tenantUserVisible.value = true;
      currentTenantUser.value = row;
    };
    const handleRefresh = async () => {
      setCurrentPage(1);
      keyword.value = '';
      _getUserPageListByTenantId();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never",
        style: {
          "padding-bottom": "20px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
          placeholder: "请输入关键字",
          style: {
            "width": "300px",
            "margin-right": "20px"
          }
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: _getUserPageListByTenantId
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: addUserHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "padding-bottom": "20px"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: true,
          data: tableData.value,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "#",
            type: "index",
            index: index => _unref(indexMethod)(index, _unref(currentPage), _unref(pageSize))
          }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
            label: "账号",
            prop: "userName"
          }), _createVNode(_component_el_table_column, {
            label: "手机号",
            prop: "mobile"
          }), _createVNode(_component_el_table_column, {
            label: "创建时间",
            prop: "createTime"
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              onClick: $event => handleUpdateUser(row),
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total, prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(TenantUser), {
        modelValue: tenantUserVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => tenantUserVisible.value = $event),
        tenantId: _unref(tenantId),
        onClearModel: _cache[2] || (_cache[2] = $event => currentTenantUser.value = null),
        model: currentTenantUser.value,
        onRefreshData: _getUserPageListByTenantId,
        formSchemas: formSchemasRef.value
      }, null, 8, ["modelValue", "tenantId", "model", "formSchemas"])]);
    };
  }
};